/* eslint-disable react/jsx-props-no-spreading */
import { useFeatures } from "@paralleldrive/react-feature-toggles";
import React from "react";
import { Redirect, Route } from "react-router-dom";

const FeatureRoute = ({ featureName, children, ...rest }) => {
  const features = useFeatures();

  if (features.includes(featureName)) {
    return <Route {...rest}>{children}</Route>;
  }
  return <Redirect to="/home" />;
};

export default FeatureRoute;
